import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IState {
  platform: string;
  version: string;
  model: string;
}

const initialState: IState = {
  platform: '-',
  version: '-',
  model: '-',
};

const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    initialize: (state) => {
      for (const key in state) {
        state[key] = initialState[key];
      }
    },
    storePlatform: (state, action: PayloadAction<string>) => {
      state.platform = action.payload;
    },
    storeVersion: (state, action: PayloadAction<string>) => {
      state.version = action.payload;
    },
    storeModel: (state, action: PayloadAction<string>) => {
      state.model = action.payload;
    },
  },
});

export const actions = applicationSlice.actions;
export default applicationSlice.reducer;
